export default {
    'remaining-samples': 'Remaining samples',
    'reason': 'Reason',
    'modify-transfer': 'Modify transfer',
    'ravages': 'Ravage',
    'free-distribution': 'Free distribution',
    'returnable': 'Returnable',
    'stocktaking': 'Stocktaking',
    'this-transfer': 'this transfer'
}